var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Check as CheckIcon } from '@mui/icons-material';
import { ModalConfirmacao } from './modal_confirmacao';
export function ModalConfirmarAprovar(props) {
    return (_jsx(ModalConfirmacao, __assign({}, props, { title: 'Confirmar Aprova\u00E7\u00E3o', titleColor: '#166534', message: _jsxs(_Fragment, { children: ["Tem certeza que deseja aprovar esta justificativa? O registro de ponto do dia voltar\u00E1 para ", _jsx("strong", { children: "Pendente" }), " aguardando sua aprova\u00E7\u00E3o final."] }), confirmText: 'CONFIRMAR APROVA\u00C7\u00C3O', submittingText: 'APROVANDO...', confirmColor: '#16A34A', confirmHoverColor: '#15803D', icon: _jsx(CheckIcon, {}) })));
}
